'use strict';

function controller (employeeDataAdapter, activeTestService) {
    const ctrl = this;

    ctrl.$onInit = () => {
        employeeDataAdapter.fetchEmployees().then(employees => {
            ctrl.employees = employees;
        });
    };
}

controller.$inject = ['employeeDataAdapter', 'activeTestService'];

export default controller;